import { BlockStatusProps, blockStatusList } from './drawer/block-status';
import {
  BlockSearchByTerm,
  BlockSortByTerm,
  BlockType,
  CommodityType,
  MilestoneType,
  Scalars,
  SortOrderByEnum,
} from '@bechtel/types';
import { t } from '@lingui/macro';

export interface SearchScopeListProps {
  id: Scalars['String'];
  name: Scalars['String'];
}

export interface SearchByListProps {
  id: Scalars['Int'];
  value: BlockSearchByTerm;
  label: Scalars['String'];
}

export const sortByList = [
  { id: 1, value: BlockSortByTerm.MOST_RECENT_UPDATE, label: t`Date Last Updated` }, //Note: DATE_LAST_UPDATED value not Accepting by Query
  { id: 2, value: BlockSortByTerm.MILESTONE_HOURS, label: t`Milestone Hours Impacted` },
];
export const searchByList = [
  { id: 1, value: BlockSearchByTerm.WP_NUMBER, label: t`Work Package Number` },
  { id: 2, value: BlockSearchByTerm.COMMODITY, label: t`Commodity Tag` },
  { id: 3, value: BlockSearchByTerm.USER_NAME, label: t`User Name` },
];

export const searchScopeList = [
  { id: 'WP_ASSIGNED', name: t`Assigned to Me` },
  { id: 'WP_ALL', name: t`All Work Packages` },
];

export interface BlockDrawerValuesProps {
  sortBy: BlockSortByTerm;
  orderBy: SortOrderByEnum;
  searchScope: SearchScopeListProps;
  searchBy: SearchByListProps;
  blockTypes: BlockType[];
  blockStatus: BlockStatusProps[];
  commodityTypes: CommodityType[];
  milestoneList: MilestoneType[];
}

export const defaultValues: BlockDrawerValuesProps = {
  sortBy: BlockSortByTerm.MOST_RECENT_UPDATE,
  orderBy: SortOrderByEnum.ASC,
  searchScope: searchScopeList[0],
  searchBy: searchByList[0], //Note: SearchBy ByDefault empty not accepting by query
  blockTypes: [],
  blockStatus: [blockStatusList[0]],
  commodityTypes: [],
  milestoneList: [],
};
